import PropTypes from 'prop-types';
import React from 'react';
import {
    Button
  } from 'carbon-components-react';
import Close16 from '@carbon/icons-react/lib/close/16';

const DeleteElementTimelineModal = ({modalDeleteVisible, modalTitle, confirmationMessage, handleDeleteModal, onElementDelete}) => {
return (
    modalDeleteVisible && (
        <div className="bx--modal bx--modal-tall is-visible">
            <div className="bx--modal-container">
                <div className="bx--modal-header">
                    <h3 className="bx--modal-header__heading">{modalTitle}</h3>
                    <Button
                    className="bx--modal-close"
                    renderIcon={Close16}
                    onClick={() => handleDeleteModal()}
                    iconDescription=""
                    />
                </div>

                <div className="bx--modal-content">
                    <div className="bx--row bx--modal-content-detail">
                        <div className="bx--col-lg-12 bx--col-md-12">
                            <h5 className="align-center">{confirmationMessage}</h5>
                        </div>
                    </div>
                </div>
                <div className="bx--modal-footer">
                    <Button
                    className="button--max-width"
                    kind="secondary"
                    onClick={() => handleDeleteModal()}
                    >
                    Cancel
                    </Button>
                    <Button className="button--max-width" kind="primary" onClick={() => onElementDelete()}>
                    Confirm
                    </Button>
                </div>
            </div>
        </div>
        )
    );
}

DeleteElementTimelineModal.propTypes = {
    modalDeleteVisible : PropTypes.bool.isRequired,
    modalTitle : PropTypes.string.isRequired,
    confirmationMessage : PropTypes.string.isRequired,
    handleDeleteModal : PropTypes.func.isRequired,
    onElementDelete : PropTypes.func.isRequired,
}

export default DeleteElementTimelineModal;